import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { STORAGE_KEYS } from '../utils/constants'

export const useAuthStore = create(
  persist(
    (set) => ({
      // Estado
      token: null,
      user: null,
      isAuthenticated: false,

      // Acciones
      setAuth: (token, user) => {
        set({
          token,
          user,
          isAuthenticated: true,
        })
      },

      clearAuth: () => {
        set({
          token: null,
          user: null,
          isAuthenticated: false,
        })
      },
    }),
    {
      name: STORAGE_KEYS.AUTH_STATE, // Usa clave separada para el estado completo
    }
  )
)
